import { Empty, List, Select } from 'antd';
import React, { useState } from 'react';
import { OptionProps, SelectProps } from 'antd/es/select';
import Modal from '../Modal';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { IS_POS } from '@/utils/env';
import { playSound } from '@/utils/sound';
import PosButton from '../PosButton';

type Props<ValueType> = {
  value?: ValueType;
  onChange?: (value: Props<ValueType>['value']) => void;
  onSelect?: (value: Props<ValueType>['value']) => void;
  children: React.ReactNode | React.ReactNode[];
  playSoundOnSelect?: boolean;
} & SelectProps<ValueType>;

const ModalSelect: React.FC<Props<string | number>> = ({
  value,
  onChange = () => {},
  onSelect = () => {},
  children,
  placeholder,
  playSoundOnSelect = false,
  ...rest
}: Props<string | number>) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      {IS_POS && (
        <Modal
          width={480}
          style={{ userSelect: 'none' }}
          styles={{ body: { padding: 0 } }}
          title={placeholder || '请选择'}
          open={visible}
          footer={
            <>
              <PosButton
                autoFocus
                onClick={() => {
                  setVisible(false);
                }}>
                取消
              </PosButton>
            </>
          }
          onCancel={() => {
            setVisible(false);
          }}>
          {React.Children.count(children) > 0 ? (
            <List size={'large'}>
              {React.Children.map(children, child => {
                const props = (child as any).props as OptionProps;
                return (
                  <List.Item
                    key={props.value}
                    onClick={() => {
                      onSelect(props.value);
                      onChange(props.value);
                      setVisible(false);
                      if (playSoundOnSelect) {
                        playSound('click');
                      }
                    }}
                    actions={[
                      value === props.value ? (
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 24 }} />
                      ) : null,
                    ]}>
                    <List.Item.Meta title={props.children} style={{ margin: 0 }} />
                  </List.Item>
                );
              })}
            </List>
          ) : (
            <Empty description={'没有可选项'} style={{ padding: '20px 0' }} />
          )}
        </Modal>
      )}
      <Select
        {...rest}
        open={IS_POS ? false : undefined}
        onChange={IS_POS ? undefined : onChange}
        onSelect={IS_POS ? undefined : onSelect}
        value={value}
        placeholder={placeholder}
        onClick={() => {
          if (IS_POS) {
            playSound('click');
            setVisible(true);
          }
        }}>
        {children}
      </Select>
    </>
  );
};

export default ModalSelect;
